import FeatureSimpleView from './FeatureSimpleView'

export default FeatureSimpleView
